import { PickersDay } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import isBetween from 'dayjs/plugin/isBetween';
import weekday from 'dayjs/plugin/weekday';
import { StyledPickersDay } from './WeekPickerDay.styles';
import { WeekPickerDayProps } from './WeekPickerDay.types';

dayjs.extend(isoWeek);
dayjs.extend(isBetween);
dayjs.extend(weekday);

export const WeekPickerDay = (props: WeekPickerDayProps) => {
  const {
    day,
    anchor,
    workingWeek,
    fourWeeks,
    eightWeeks,
    weekStartsOn = 1,
    outsideCurrentMonth,
    ...other
  } = props;

  if (!anchor) {
    return (
      <PickersDay
        day={day}
        outsideCurrentMonth={outsideCurrentMonth}
        {...other}
      />
    );
  }
  const anchorDay = dayjs(anchor);

  const weekStart =
    weekStartsOn === 1
      ? anchorDay.startOf('isoWeek')
      : anchorDay.startOf('week');

  const weekEnd = eightWeeks
    ? weekStart.add(8, 'week').subtract(1, 'day')
    : fourWeeks
    ? weekStart.add(4, 'week').subtract(1, 'day')
    : workingWeek
    ? weekStart.add(4, 'day')
    : weekStartsOn === 1
    ? anchorDay.endOf('isoWeek')
    : anchorDay.endOf('week');

  const current = dayjs(day);
  const inWeek = current.isBetween(weekStart, weekEnd, 'day', '[]');
  const first = current.isSame(weekStart, 'day');
  const last = current.isSame(weekEnd, 'day');

  return (
    <StyledPickersDay
      {...other}
      day={current.toDate()}
      outsideCurrentMonth={outsideCurrentMonth}
      disableMargin
      inWeek={inWeek}
      first={first}
      last={last}
    />
  );
};
